import React from "react";
import "./CustomInput.scss";

const CustomInput = ({
  label,
  value,
  onChange,
  classname,
  isReadOnly,
  isDisabled,
  type,
  classNameDivInput,
  register,
  min, // new prop
}) => {
  const handleChange = (e) => {
    let val = e.target.value;
    if (type === "number" && min !== undefined) {
      val = val < min ? min : val; // enforce minimum value
    }
    onChange && onChange({ ...e, target: { ...e.target, value: val } });
  };

  return (
    <div className={classNameDivInput}>
      <label style={{ fontSize: "16px" }} className="label-input">
        {label}
      </label>
      <input
        type={type}
        value={value}
        onChange={handleChange}
        className={classname}
        readOnly={isReadOnly}
        disabled={isDisabled}
        required
        min={min}
        {...register}
      />
    </div>
  );
};

export default CustomInput;
